<template>
  <main>

    <div id="modalEliminarUsuario" class="modal">
      <div class="modal-content">
        <h4>Eliminar usuario</h4>
        <p>
          Estas a punto de eliminar a {{ usuarioSeleccionado.nombre }}, esta
          accion no se puede revertir, ¿estas seguro que deseas eliminarlo?
        </p>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >Volver</a
        >
        <a
          class=" waves-effect waves-green btn-flat"
          @click="showModal('eliminarUsuario')"
          >Eliminar</a
        >
      </div>
    </div>
    <div class="row  main">
      <div class="col card-panel s6 offset-s3">
        <div v-show="opcion === 'registrar'">


          <span class="page-title center-align">Registrar Usuario</span>
          <form>
            <div class="row">

            <div class="input-field col s10 push-s1">
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />

              <span
                class="material-symbols-outlined icons-in-form large material-icons prefix"
              >
                account_circle
              </span>
              <input
                v-model="username"
                id="username"
                type="text"
                maxlength="50"
              />
              <label for="username">Username</label>
            </div>
            <div class="input-field col s10 push-s1">
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <span
                class="material-symbols-outlined icons-in-form large material-icons prefix"
              >
                badge
              </span>
              <input
                v-model="nombre"
                id="nombreCompleto"
                type="text"
                maxlength="100"
              />
              <label for="nombreCompleto">Nombre completo</label>
            </div>
            <div class="input-field col s10 push-s1">
              <i
                class="icons-in-form large material-icons fa fa-phone  prefix "
              ></i>
              <input
                v-model="numeroTel"
                id="numeroTel"
                type="text"
                maxlength="13"
              />
              <label for="numeroTel">Número de teléfono</label>
            </div>


              <div class=" col s10 push-s1" style="padding: 0">
                <InputPassword  v-model:password="password"
                                v-model:confirmPassword="confirmPassword"
                                v-model:nivel="nivel"
                                ref="inputPasswordRef"
                ></InputPassword>
              </div>




<!--            <div class="input-field col s10 push-s1">-->
<!--              <i class="icons-in-form large material-icons prefix "-->
<!--                >fingerprint</i-->
<!--              >-->
<!--              <input v-model="password" id="password" type="password" />-->
<!--              <label for="password">Contraseña</label>-->
<!--            </div>-->
<!--            <div class="input-field col s10 push-s1">-->
<!--              <i class="icons-in-form large material-icons prefix "-->
<!--                >check_circle</i-->
<!--              >-->
<!--              <input-->
<!--                v-model="confirmPassword"-->
<!--                id="confirmPassword"-->
<!--                type="password"-->
<!--              />-->
<!--              <label for="confirmPassword">Confirmacion de contraseña</label>-->
<!--            </div>-->

            <div class="input-field col s10 push-s1">
              <select v-model="nivel">
<!--                <option v-if="miNivel === '1'" value="1">Administrador</option>-->
                <option v-if="miNivel === '1'" value="2">Vendedor/Lider</option>
                <option v-if="permisos.includes('USUARIO_CLIENTE')" value="3"
                  >Cliente</option
                >
              </select>

              <label class="etiquetas">Tipo de usuario</label>
<!--               <i
                class="icons-in-form large material-icons fa fa-phone  prefix "
              ></i> -->
            </div>
            <div class="input-field col s5 push-s1">
              <input
                type="text"
                class="validate input-filtros"
                :id="titulos[0].llave"
                @focusin="focusN(true)"
                @focusout="focusN(false)"
                placeholder="Sin lider"
                @input="filtro"
                v-model="selectedLider"
              />
              <label :for="titulos[0].llave">Asociar un líder</label>
              <div
                v-if="focus"
                style="height: 200px; overflow-y: auto; position: fixed; z-index: 100; width: 400px"
                class="card-panel"
                id="selectF"
                @scroll="mas"
              >
                <table class="striped highlight ">
                  <tbody>
                    <tr>
                      <td
                        @click="setLider('Sin lider')"
                        style="cursor: pointer"
                      >
                        Sin lider
                      </td>
                    </tr>
                    <tr v-for="fila in lideres">
                      <td @click="setLider(fila)" style="cursor: pointer">
                        {{ fila }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!--              <select v-model="selectedLider">-->
              <!--                <option value="0" v-if="miNivel==='1'">Sin lider</option>-->
              <!--                <option v-for="lider in lideres" :value="lider">{{lider}}</option>-->
              <!--              </select>-->
              <!--              <label class="etiquetas">Asociar un lider</label>-->
            </div>
            <div class="input-field col s5 offset-s1" v-if="miNivel != 2">
              <i class="icons-in-form large material-icons prefix ">block</i>
              <input
                v-model="maxRecargas"
                id="maxRecargas"
                type="number"
                min="1"
                :max="
                  (empresa == 'gsmoviles' || empresa == 'teletrial') &&
                  nivel == 3 &&
                  miNivel !== '1'
                    ? 5
                    : 1000000
                "
              />
              <label for="maxRecargas">Máximo de recargas al día</label>
            </div>
            <div class="input-field col s5 offset-s1" v-if="miNivel == 2">
              <i class="icons-in-form large material-icons prefix ">block</i>
              <input
                v-model="maxRecargas"
                id="maxRecargas"
                type="number"
                min="1"
                :max="
                  (empresa == 'gsmoviles' || empresa == 'teletrial') &&
                  nivel == 3 &&
                  miNivel !== '1'
                    ? 5
                    : MRD
                "
              />
              <label for="maxRecargas">Máximo de recargas al día</label>
            </div>
            <div
              v-show="selectedLider.length >= 1 && nivel === '3'"
              class="input-field col s10 push-s1"
            >
              <!--              <input  type="text" class="validate input-filtros" :id="titulos[1].llave"  @focusin="focusNC(true)" @focusout="focusNC(false)"-->
              <!--                      placeholder="Sin lider" @input="filtroC" v-model="selectedCliente">-->
              <!--              <label :for="titulos[1].llave">Asociar un lider</label>-->
              <!--              <div v-if="focusC" style="height: 150px; overflow-y: auto; position: fixed; z-index: 100; width: 800px" class="card-panel" id="selectFC" @scroll="masC">-->
              <!--                <table class="striped highlight " >-->
              <!--                  <tbody >-->
              <!--                  <tr v-for="(fila) in clientes" >-->
              <!--                    <td @click="setCliente(fila)" style="cursor: pointer">{{ fila }}</td>-->
              <!--                  </tr>-->
              <!--                  </tbody>-->
              <!--                </table>-->
              <!--              </div>-->

              <input
                type="text"
                v-model="selectedCliente"
                list="selectedClientes"
                id="inputCliente"
              />
              <label for="inputCliente">Asociar un cliente</label>
              <datalist id="selectedClientes">
                <option v-for="cliente in clientes" :value="cliente" />
              </datalist>
            </div>
            <span class="mensaje-error col s12 center">{{ mensaje }}</span>
            <div class="col s10 push-s1"  style="justify-content: space-between; display: flex;">
              <div
                  class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                  @click="limpiarRegistro"
                  data-position="bottom"
                  data-tooltip="Limpiar campos"
              >
                <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
                />
                <span class="material-symbols-outlined btn-style">
                  mop
                </span>
              </div>
              <div
                  class=" waves-effect waves-light btn tooltipped blue-grey darken-3 "
                  @click="validaFormulario('registrarUsuario')"
                  data-position="bottom"
                  data-tooltip="Registrar Usuario"
              >
                <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
                <span class="material-symbols-outlined btn-style">
                  how_to_reg
                </span>
              </div>
              </div>
            </div>
          </form>
        </div>
        <div v-show="opcion === 'consultar'">
          <span class="titulo center-align"
            >{{ usuarioSeleccionado.username }}.</span
          >
          <a
            v-show="usuarioSeleccionado.username"
            class="btn-floating btn-large waves-effect waves-light red eliminar modal-trigger"
            href="#modalEliminarUsuario"
            ><i class="material-icons">delete</i></a
          >
          <form>
            <div class="input-field col s10 push-s1">
              <i class="icons-in-form large material-icons prefix"
                >accessibility</i
              >
              <input
                v-model="nombreEditar"
                id="nombreEditar"
                type="text"
                maxlength="100"
              />
              <label for="nombreEditar">Nombre completo</label>
            </div>
            <div class="input-field col s10 push-s1">
              <i class="icons-in-form large material-icons prefix "
                >accessibility</i
              >
              <input
                v-model="numeroTele"
                id="numeroTele"
                type="text"
                maxlength="13"
              />
              <label for="numeroTele">Número de teléfono</label>
            </div>
            <div class=" col s10 push-s1" style="padding: 0">
              <InputPassword  v-model:password="passwordEditar"
                              v-model:confirmPassword="confirmarPasswordEditar"
                              :nivel="nivelEditar"
                              ref="inputPasswordEditRef"
              ></InputPassword>
            </div>
<!--            <div class="input-field col s10 push-s1">-->
<!--              <i class="icons-in-form large material-icons prefix"-->
<!--                >fingerprint</i-->
<!--              >-->
<!--              <input v-model="passwordEditar" id="pass-ed" type="password" />-->
<!--              <label for="pass-ed">Contraseña</label>-->
<!--            </div>-->
<!--            <div class="input-field col s10 push-s1">-->
<!--              <i class="icons-in-form large material-icons prefix"-->
<!--                >check_circle</i-->
<!--              >-->
<!--              <input-->
<!--                v-model="confirmarPasswordEditar"-->
<!--                id="confirm-ed"-->
<!--                type="password"-->
<!--              />-->
<!--              <label for="confirm-ed">Confirmación de contraseña</label>-->
<!--            </div>-->
            <div class="input-field col s10 push-s1">
              <select v-model="nivelEditar">
<!--                <option v-if="miNivel === '1'" value="1">Administrador</option>-->
                <option v-if="miNivel === '1'" value="2">Vendedor/Lider</option>
                <option v-if="permisos.includes('USUARIO_CLIENTE')" value="3"
                  >Cliente</option
                >
              </select>
              <label class="etiquetas">Tipo de usuario</label>
            </div>

            <div class="input-field col s5 push-s1">
              <input
                type="text"
                class="validate input-filtros"
                :id="titulos[0].llave"
                @focusin="focusNC(true)"
                @focusout="focusNC(false)"
                placeholder="Sin lider"
                @input="filtro"
                v-model="selectedLiderEditar"
              />
              <label :for="titulos[0].llave">Asociar un líder</label>
              <div
                v-if="focusC"
                style="height: 200px; overflow-y: auto; position: fixed; z-index: 100; width: 400px"
                class="card-panel"
                id="selectFE"
                @scroll="mas"
              >
                <table class="striped highlight ">
                  <tbody>
                    <tr>
                      <td
                        @click="setLiderEdit('Sin lider')"
                        style="cursor: pointer"
                      >
                        Sin lider
                      </td>
                    </tr>
                    <tr v-for="fila in lideres">
                      <td @click="setLiderEdit(fila)" style="cursor: pointer">
                        {{ fila }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--              <select v-model="selectedLiderEditar">-->
              <!--                <option v-if="miNivel==='1'" value="0">Sin lider</option>-->
              <!--                <option v-for="lider in lideres" :value="lider">{{lider}}</option>-->
              <!--              </select>-->
              <!--              <label class="etiquetas">Asociar un lider</label>-->
            </div>
            <div class="input-field col s5 offset-s1" v-if="miNivel != 2">
              <i class="icons-in-form large material-icons prefix ">block</i>
              <input
                v-model="maxRecargasEditar"
                id="maxRecargasEdit"
                type="number"
                min="1"
                :max="
                  (empresa == 'gsmoviles' || empresa == 'teletrial') &&
                  nivelEditar == 3 &&
                  miNivel !== '1'
                    ? 5
                    : 1000000
                "
              />
              <label for="maxRecargasEdit">Máximo de recargas al día</label>
            </div>
            <div class="input-field col s5 offset-s1" v-if="miNivel == 2">
              <i class="icons-in-form large material-icons prefix ">block</i>
              <input
                v-model="maxRecargasEditar"
                id="maxRecargasEdit"
                type="number"
                min="1"
                :max="
                  (empresa == 'gsmoviles' || empresa == 'teletrial') &&
                  nivelEditar == 3 &&
                  miNivel !== '1'
                    ? 5
                    : MRD
                "
              />
              <label for="maxRecargasEdit">Máximo de recargas al día</label>
            </div>
            <div
              v-show="
                selectedLiderEditar &&
                  selectedLiderEditar.length > 1 &&
                  nivelEditar === '3'
              "
              class="input-field col s10 push-s1"
            >
              <input
                type="text"
                v-model="selectedClienteEditar"
                list="editClientes"
                id="inputClienteEditar"
              />
              <label for="inputClienteEditar">Asociar un cliente</label>
              <datalist id="editClientes">
                <option v-for="cliente in clientes" :value="cliente" />
              </datalist>
            </div>
            <span class="mensaje-error col s12 center">{{ mensaje }}</span>
            <div class="col s10 push-s1"  style="justify-content: space-between; display: flex;">
              <div
                  class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                  @click="limpiarRegistro"
                  data-position="bottom"
                  data-tooltip="Limpiar campos"
              >
                <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
                />
                <span class="material-symbols-outlined btn-style">
                  mop
                </span>
              </div>
              <div
                  class=" waves-effect waves-light btn tooltipped blue-grey darken-3 "
                  @click="validaFormulario('editarUsuario')"
                  data-position="bottom"
                  data-tooltip="Editar Usuario"
              >
                <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
                <span class="material-symbols-outlined btn-style">
                  how_to_reg
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  getUsuarios,
  registrarUsuario,
  editarUsuario,
  eliminarUsuario,
  getLideres,
  getClientes,
} from "@/api/api";
import { mapState } from "vuex";
import {emitter} from "@/eventBus";
import InputPassword from "./formularios/inputPassword"

let clientesStore = [];
let datosRecibios = [];
let datosAMostrar = [];
let datosRecibiosC = [];
let datosAMostrarC = [];
let copyTitulos = [];
let datosEncontrados = 0;
let filtros = {};
let usuario;

export default {
  name: "usuarioNew",
  components:{
    InputPassword
  },
  data() {
    return {
      usuarios: [],
      usuariosM: [],
      numeroTel: null,
      numeroTele: null,
      usuarioValue: "0",
      liderValue: "0",
      datos: {},
      usuarioSeleccionado: {},
      mensaje: "",
      MRD: false,
      username: "",
      nombre: "",
      nombreEditar: "",
      password: "",
      passwordEditar: "",
      confirmPassword: "",
      confirmarPasswordEditar: "",
      nivelEditar: "2",
      nivel: "2",
      opcion: "registrar",
      lideres: [],
      selectedLider: "",
      selectedLiderEditar: "0",
      maxRecargas: "5",
      maxRecargasEditar: "",
      selectedCliente: "",
      selectedClienteEditar: "",
      clientes: [],
      empresa: "",
      focus: false,
      focusC: false,
      miNivel: "",
      googleCode: '',
      latitude: '',
      longitude: '',
      titulos: [
        { llave: "lider", valor: "Lider" },
        { llave: "cliente", valor: "Cliente" },
      ],
    };
  },

  beforeDestroy(){
    emitter.off('enviarCodigo')
  },
  mounted() {
    if(!this.listenerRegistered) {
      emitter.on('enviarCodigo', (data) => {
        console.log(data, `emiter`)
        this.latitude = data.latitude
        this.longitude = data.longitude
        this.googleCode = data.googleCode
        console.log(data.googleCode)

        if (data.event == 'registrarUsuario') this.registrar()
        else if (data.event == 'editarUsuario') this.editar()
        else if (data.event == 'eliminarUsuario') this.eliminar()
      });
      this.listenerRegistered = true;
    }

    this.miNivel = localStorage.nivel;
    this.empresa = localStorage.empresa;
    this.nivel = this.miNivel === "2" ? "3" : "1";
    this.nivelEditar = this.miNivel === "2" ? "3" : "1";
    this.selectedLiderEditar = localStorage.lider;
    console.log(159);
    clientesStore = [];
    datosRecibios = [];
    datosAMostrar = [];

    this.$nextTick(() => {
      M.AutoInit();
      M.updateTextFields();
      this.getUsers();

      // document.getElementById('selectF').scroll(() => {
      //   if ( 50 < document.getElementById('selectF').scrollTop() + document.getElementById('selectF').height() + 50) {
      //     this.agregar100()
      //   }
      // })
    });
  },
  methods: {
    focusN(value) {
      if (!value)
        setTimeout(() => {
          this.focus = value;
        }, 200);
      else this.focus = value;
    },
    focusNC(value) {
      if (!value)
        setTimeout(() => {
          this.focusC = value;
        }, 200);
      else this.focusC = value;
    },
    mas(e) {
      //console.log(event.srcElement.scrollHeight < event.srcElement.clientHeight + event.srcElement.scrollTop +1 )
      if (
        event.srcElement.scrollHeight <
        event.srcElement.clientHeight + event.srcElement.scrollTop + 1
      ) {
        this.agregar100();
      }
    },
    masC(e) {
      //console.log(event.srcElement.scrollHeight < event.srcElement.clientHeight + event.srcElement.scrollTop +1 )
      if (
        event.srcElement.scrollHeight <
        event.srcElement.clientHeight + event.srcElement.scrollTop + 1
      ) {
        this.agregar100();
      }
    },
    setCliente(lider) {
      this.selectedCliente = lider;
      this.focus = false;
    },
    setLider(lider) {
      this.selectedLider = lider;
      this.focus = false;
    },
    setLiderEdit(lider) {
      this.selectedLiderEditar = lider;
      this.focus = false;
    },
    agregar100() {
      this.lideres = this.lideres.concat(datosAMostrar.slice(0, 10));
      datosAMostrar.splice(0, 10);
    },
    agregar100C() {
      this.clientes = this.clientes.concat(datosAMostrarC.slice(0, 10));
      datosAMostrarC.splice(0, 10);
    },
    filtro(evento) {
      filtros[evento.target.id] = evento.target.value;
      this.lideres = [];
      datosAMostrar = datosRecibios.slice();
      if (this.selectedLider !== "")
        datosAMostrar = datosAMostrar.filter((fila) =>
          fila.includes(this.selectedLider)
        );
      this.titulo = `${datosAMostrar.length} encontrados`;
      this.agregar100();
    },
    filtroC(evento) {
      filtros[evento.target.id] = evento.target.value;
      this.clientes = [];
      datosAMostrarC = datosRecibiosC.slice();
      if (this.selectedCliente !== "")
        datosAMostrarC = datosAMostrarC.filter((fila) =>
          fila.includes(this.selectedCliente)
        );
      this.titulo = `${datosAMostrar.length} encontrados`;
      this.agregar100C();
    },
    getUsers() {
      getUsuarios()
        .then((respuesta) => {
          this.usuarios = respuesta.usuarios;
          if (this.$route.params.id) {
            this.usuarioValue = this.$route.params.id;
            this.opcion = "consultar";
          }
        })
        .catch((error) => {
          console.log(error);
        });

      if (localStorage.nivel == 2) this.MRD = localStorage.MRD;

      if (localStorage.nivel < 2) {
        getLideres()
          .then((respuesta) => {
            datosAMostrar = respuesta.lideres.slice();
            datosRecibios = respuesta.lideres.slice();
            this.agregar100();

            //this.lideres = respuesta.lideres
            // this.$nextTick(()=>{
            //   M.AutoInit()
            // })
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.selectedLider = localStorage.lider;
        datosAMostrar = [localStorage.lider];
        datosRecibios = [localStorage.lider];
        this.agregar100();
      }

      getClientes()
        .then((respuesta) => {
          clientesStore = respuesta.clientes;

          if (this.miNivel === "2") {
            //datosAMostrarC = clientesStore.filter(clienteLider=>clienteLider.lider===this.selectedLider ).map(clienteLider=>clienteLider.cliente)
            //datosRecibiosC = datosAMostrarC.slice()
            this.clientes = clientesStore
              .filter(
                (clienteLider) => clienteLider.lider === this.selectedLider
              )
              .map((clienteLider) => clienteLider.cliente);
            M.AutoInit();
            //this.agregar100C()
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },


    validaFormulario(event){
      console.log(this.passwordEditar)
      if(event == 'editarUsuario' && this.passwordEditar != '......' && this.confirmarPasswordEditar  != '......'){
        if (!this.$refs.inputPasswordEditRef.validPassword())
          return M.toast({
            html: `Contraseña invalida`,
            classes: "rounded",
            displayLength: 3000,
          });
        if (!this.$refs.inputPasswordEditRef.validconfirmPassword())
          return M.toast({
            html: `Las Contraseñas no coinciden`,
            classes: "rounded",
            displayLength: 3000,
          });
      }
      else if(event == 'registrarUsuario'){
        if (!this.$refs.inputPasswordRef.validPassword())
          return M.toast({
            html: `Contraseña invalida`,
            classes: "rounded",
            displayLength: 3000,
          });
        if (!this.$refs.inputPasswordRef.validconfirmPassword())
          return M.toast({
            html: `Las Contraseñas no coinciden`,
            classes: "rounded",
            displayLength: 3000,
          });
        if (
            this.username.trim().length === 0 ||
            this.nombre.trim().length === 0 ||
            this.password.trim().length === 0
        )
          return M.toast({
            html: "Introduce todos los campos",
            classes: "rounded",
            displayLength: 3000,
          });
      }



      if (this.numeroTel && !parseInt(this.numeroTel))
        return M.toast({
          html: "Número telefónico no válido",
          classes: "rounded",
          displayLength: 3000,
        });
      if (
          (this.empresa == "gsmoviles" || this.empresa == "teletrial") &&
          this.nivel == 3 &&
          this.miNivel !== "1" &&
          this.maxRecargas > 5
      )
        return M.toast({
          html: "el Numero de recargas maximas son 5",
          classes: "rounded",
          displayLength: 3000,
        });
      //nivelEditar== 3 && miNivel!=='1'
      // if (!datosRecibios.find(d => d== this.selectedLider) && this.selectedLider.length) return M.toast({html: 'Selecciona un lider correcto', classes: 'rounded', displayLength: 3000})
      if (this.nivel === "3" && this.selectedCliente === "")
        return M.toast({
          html: "Selecciona un cliente para ese nivel de usuario",
          classes: "rounded",
          displayLength: 3000,
        });

      if (this.miNivel == 2 && parseInt(this.maxRecargas) > parseInt(this.MRD))
        return M.toast({
          html: `El numero de recargas maximo es ${this.MRD}`,
          classes: "rounded",
          displayLength: 3000,
        });
      if (this.selectedLider == "Sin lider") this.selectedLider = "0";


      this.showModal(event)

    },

    showModal(event){
      if(this.miNivel==1 && (
          this.empresa != 'demo'
      )){
        console.log(`emit`)
        setTimeout(() => $("#modalEliminarUsuario").modal("close"), 1);
        emitter.emit('showModal', {event});
      }
      else {
        console.log(event)
        if(event == 'registrarUsuario' ) this.registrar()
        else if(event == 'editarUsuario') this.editar()
        else if(event == 'eliminarUsuario') {
          setTimeout(() => $("#verificationCode").modal("close"), 1);
          this.eliminar()
        }
      }

    },



    registrar() {




      this.$store.commit("ponerBarra");
      registrarUsuario(
        this.username,
        this.nombre,
        this.password,
        this.nivel,
        this.selectedLider,
        this.selectedCliente,
        this.maxRecargas,
        parseInt(this.numeroTel),
        this.latitude,
        this.longitude,
        this.googleCode,
      )
        .then(() => {
          this.$store.commit("quitarBarra");
          this.mensaje = "Registrado correctamente";
          this.limpiarRegistro();
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log(error);
          this.mensaje = error.mensaje;
        });
    },
    editar() {
      console.log(this.usuarioSeleccionado, `asdasd, asda222`)
      if (!this.usuarioSeleccionado.username){
        console.log(this.usuarioSeleccionado, `entro aqui`)
        return M.toast({
          html: "Selecciona un usuario",
          classes: "rounded",
          displayLength: 3000,
        });
      }
      if (
        (this.empresa == "gsmoviles" || this.empresa == "teletrial") &&
        this.nivelEditar == 3 &&
        this.miNivel !== "1" &&
        this.maxRecargasEditar > 5
      )
        return M.toast({
          html: "el Numero de recargas maximas son 5",
          classes: "rounded",
          displayLength: 3000,
        });
      if (this.numeroTele && !parseInt(this.numeroTele))
        return M.toast({
          html: "Número telefónico no válido",
          classes: "rounded",
          displayLength: 3000,
        });
      if (
        this.nombreEditar.trim().length === 0 ||
        this.passwordEditar.trim().length === 0
      )
        return M.toast({
          html: "Introduce todos los campos",
          classes: "rounded",
          displayLength: 3000,
        });
      if (this.passwordEditar !== this.confirmarPasswordEditar)
        return M.toast({
          html: "Las contraseñas no coinciden",
          classes: "rounded",
          displayLength: 3000,
        });
      console.log(
        parseInt(this.maxRecargas) > parseInt(this.MRD),
        this.maxRecargas,
        this.MRD
      );
      if (this.miNivel == 2 && parseInt(this.maxRecargas) > parseInt(this.MRD))
        return M.toast({
          html: `El numero de recargas maximo es ${this.MRD}`,
          classes: "rounded",
          displayLength: 3000,
        });
      this.$store.commit("ponerBarra");
      if (this.passwordEditar === "......") {
        this.passwordEditar = undefined;
        this.confirmarPasswordEditar = undefined;
      }
      if (this.selectedLiderEditar == "Sin lider") this.selectedLider = "0";
      editarUsuario(
        this.nombreEditar,
        this.passwordEditar,
        this.nivelEditar,
        this.usuarioValue,
        this.selectedLiderEditar,
        this.selectedClienteEditar,
        this.maxRecargasEditar,
        parseInt(this.numeroTele),
        this.latitude,
        this.longitude,
        this.googleCode,
      )
        .then(() => {
          if (this.passwordEditar === undefined) {
            this.passwordEditar = "......";
            this.confirmarPasswordEditar = "......";
          }
          this.$store.commit("quitarBarra");
          this.mensaje = "Editado correctamente";
          //this.usuarioValue = '0'
          this.getUsers();
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log(error);
          this.mensaje = error.mensaje;
        });
    },
    limpiarRegistro() {
      console.log(132132)
      this.username = "";
      this.nombre = "";
      this.password = "";
      this.confirmPassword = "";
      this.clientes = [];
      this.selectedLider = "";
    },
    limpiarEditar() {
      this.nombreEditar = "";
      this.passwordEditar = "";
      this.confirmarPasswordEditar = "";
      this.nivelEditar = "1";
      this.selectedLiderEditar = "";
    },
    eliminar() {
      eliminarUsuario(this.usuarioValue, this.latitude,
          this.longitude,
          this.googleCode,)
        .then(() => {
          this.$store.commit("quitarBarra");
          M.toast({
            html: "Eliminado correctamente",
            classes: "rounded",
            displayLength: 5000,
          });
          this.$router.push({name: 'usuarios'})
          this.usuarioSeleccionado = { nombre: "" };
          this.getUsers();
          this.usuarioValue = "0";
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log(error);
          this.mensaje = error.mensaje;
        });
    },
  },
  watch: {
    usuarioValue(id) {
      console.log(123);
      if (id === "0") return this.limpiarEditar();
      this.mensaje = "";
      this.usuarioSeleccionado = this.usuarios.find((usr) => usr.id === id);
      console.log(this.usuarioSeleccionado);
      this.nombreEditar = this.usuarioSeleccionado.nombre || "";
      this.passwordEditar = "......";
      this.confirmarPasswordEditar = "......";
      this.numeroTele =
        this.usuarioSeleccionado.phoneNumber &&
        this.usuarioSeleccionado.phoneNumber != `null`
          ? this.usuarioSeleccionado.phoneNumber
          : "";
      this.nivelEditar = this.usuarioSeleccionado.nivel || "1";
      this.selectedLiderEditar =
        this.usuarioSeleccionado.lider == 0
          ? ""
          : this.usuarioSeleccionado.lider;
      this.selectedClienteEditar =
        this.usuarioSeleccionado.cliente == 0
          ? ""
          : this.usuarioSeleccionado.cliente;
      this.maxRecargasEditar = this.usuarioSeleccionado.maxRecargas || "10";
      this.$nextTick(() => {
        M.AutoInit();
        M.updateTextFields();
      });
    },
    selectedLider(val) {
      this.clientes = clientesStore
        .filter((clienteLider) => clienteLider.lider === val)
        .map((clienteLider) => clienteLider.cliente);
      this.$nextTick(() => M.AutoInit());
    },
    selectedLiderEditar(val) {
      this.clientes = clientesStore
        .filter((clienteLider) => clienteLider.lider === val)
        .map((clienteLider) => clienteLider.cliente);
      this.$nextTick(() => M.AutoInit());
    },
    permisos() {
      this.$nextTick(() => M.AutoInit());
    },
  },
  beforeCreate() {
    if (localStorage.nivel === "3")
      return this.$router.push({
        name: "login",
        params: { empresa: localStorage.empresa },
      });
  },
  computed: {
    ...mapState(["permisos"]),
  },
};
</script>

<style scoped>

.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
.btn {
  width: 70px;
  text-align-last: center;
}
.btn-style {
  margin-top: 5px;
}
.titulo {
  font-size: 2.2em;
  display: block;
  margin-top: 5px;
  font-family: "Roboto", serif;
  font-weight: lighter;
}

.prefix {
  font-size: 1.4em;
  margin-top: 10px;
}

.card-panel {
  border-radius: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.icono-izquierda {
  left: 0;
}

.left {
  margin-left: 10px;
}

.recargas {
  width: 31%;
  margin-left: 3%;
}

.movimientos {
  width: 80%;
  margin-left: 10%;
  overflow-y: auto;
  max-height: 85vh;
}

.main {
  margin-top: 20px;
}

.mensaje-error {
  font-size: 1.5em;
  margin-bottom: 15px;
  font-family: "Roboto", serif;
  color: #b80009;
}

.eliminar {
  margin-top: -70px;
  margin-right: 8px;
}

.boton-margen-derecho {
  margin-right: 10px;
}

.boton-margen-izquierdo {
  margin-left: 10px;
}

.input-field {
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
}

.card-panel {
  padding-top: 5px;
}

.icons-in-form {
  /*margin-left: -10px !important;*/
}

@media (max-width: 900px) {
  .recargas {
    width: 92%;
    margin-left: 4%;
  }

  .movimientos {
    width: 92%;
    margin-left: 4%;
  }
}
</style>
